export default __webpack_public_path__ + "static/media/RTR1802V_Frente.8d24864d.webp";